import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'course.Manage training fields' | translate }}</h1>
            <a ng-if="vm.canManageCourses" class="btn add" ui-sref="authorized.courses.fields.add()">{{ 'course.Add training field' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('value')"><a ng-click="vm.list.sortBy('value')">{{ 'course.Field' | translate }}</a></th>
                        <th ng-class="vm.list.getSortClass('courseCount')"><a ng-click="vm.list.sortBy('courseCount')">{{ 'course.Courses' | translate }}</a></th>
                        <!--<th>{{ 'course.Status' | translate }}</th>-->
                        <th class="actions">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>{{ item.activeI18n.value }}</td>
                        <td>{{ item.courseCount}}</td>
                        <!--<td class="todo">Active</td>-->
                        <td class="actions">
                            <a class="btn edit" ng-if="vm.canManageCourses"
                            ui-sref="authorized.courses.fields.detail({ id: item.id })">{{ 'course.Edit' | translate }}</a>
                            <a class="btn delete" ng-if="vm.canManageCourses" ng-click="vm.delete(item)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor (DATATABLES, CLASSIFIER_ENUM, ListFactory, ClassifierResource, PrivilegeService, $translate, ModalService, toastr) {
        this.DATATABLES = DATATABLES;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ListFactory = ListFactory;
        this.ClassifierResource = ClassifierResource;
        this.PrivilegeService = PrivilegeService;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.toastr = toastr;
    }

    $onInit () {
        this.canManageCourses = this.PrivilegeService.canManageCourses();
        this.list = this.ListFactory.createWithPagination(this.ClassifierResource.query.bind(this.ClassifierResource));
        this.list.fetch({ type: this.CLASSIFIER_ENUM.KEYS.FIELD, expand: 'activeI18n' });
    }

    delete (item) {
        const confirmMessage = this.$translate.instant('classifier.Are you sure you wish to delete the training field?');

        this.ModalService.confirm(confirmMessage, 'medium').then(() => {
            this.ClassifierResource.delete({ id: item.id }).$promise.then(() => {
                this.list.fetch();
                this.toastr.success(this.$translate.instant('classifier.Training field deleted'));
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/fields/list/index.js